import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { PawPrint } from "@phosphor-icons/react";
import { useCart } from "@/context/CartContext";

// STEREO cart flair: an over-the-object popup + a paw coin that flies into the Empire Total.
export default function CartFlourish() {
  const { lastAdd } = useCart();
  const [popup, setPopup] = useState(null);

  useEffect(() => {
    if (!lastAdd) return;
    setPopup(lastAdd);
    const t = setTimeout(() => setPopup(null), 1700);
    return () => clearTimeout(t);
  }, [lastAdd]);

  return (
    <>
      {/* paw coin flying into the Empire Total (bottom-left) */}
      <AnimatePresence>
        {lastAdd && (
          <motion.div key={`coin-${lastAdd.id}`}
            initial={{ top: "42%", left: "50%", scale: 1, opacity: 1, rotate: 0 }}
            animate={{ top: "calc(100vh - 44px)", left: 44, scale: 0.35, opacity: 0, rotate: 220 }}
            transition={{ duration: 0.95, ease: [0.6, 0.05, 0.3, 1] }}
            className="fixed z-[60] -translate-x-1/2 -translate-y-1/2 pointer-events-none"
            data-testid="cart-fly-coin">
            <div className="h-14 w-14 rounded-full bg-primary grid place-items-center neon-glow shadow-2xl">
              <PawPrint weight="fill" size={26} className="text-primary-foreground" />
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* over-the-object confirmation popup */}
      <AnimatePresence>
        {popup && (
          <motion.div key={`pop-${popup.id}`}
            initial={{ opacity: 0, y: -24, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -16, scale: 0.95 }}
            transition={{ type: "spring", stiffness: 320, damping: 24 }}
            className="fixed top-6 left-1/2 -translate-x-1/2 z-[61] flex items-center gap-3 pl-2 pr-5 py-2 rounded-full bg-popover/95 backdrop-blur border border-primary/50 neon-glow"
            data-testid="cart-flourish">
            {popup.image
              ? <img src={popup.image} alt="" className="h-11 w-11 rounded-full object-cover border border-primary/40" />
              : <span className="h-11 w-11 rounded-full grid place-items-center bg-primary/20 border border-primary/40"><PawPrint weight="fill" size={20} className="text-primary" /></span>}
            <div className="leading-tight max-w-[220px]">
              <span className="overline text-primary block">Added to the Empire</span>
              <span className="text-sm text-white font-modern block truncate" data-testid="cart-flourish-name">{popup.name}</span>
            </div>
            <span className="ml-1 text-primary font-modern whitespace-nowrap" data-testid="cart-flourish-price">+${popup.price.toLocaleString()}</span>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
